import React from "react";

export default function ChildrenPrivacyPolicy() {
  return (
    <div className="agreement-page" style={{ padding: "20px", maxWidth: "900px", margin: "0 auto" }}>
      <h1>伴知宠儿童隐私保护政策</h1>
      <p>
        本页面为《伴知宠儿童隐私保护政策》的展示页。我们重视对未成年人个人信息的保护，具体条款内容请以伴知宠官方最新公布为准。
      </p>
      <p>
        若用户为14周岁以下儿童，请在监护人同意后使用我们的产品或服务。
      </p>
    </div>
  );
}
